export const REQUIRE_IMAGE_ALT = true;
export const ENFORCE_EMBED_PROVIDER = false;
export const PREVIEW_TOKEN_MAX_AGE_MS = 24 * 60 * 60 * 1000;
